import React from 'react';
import { Box, Button } from '@ally/metronome-ui';
export default function LogoutButton({ focusRef, handleLogout, lastLoginTime, }) {
    return (React.createElement(Box, { mt: "lg" },
        React.createElement(Button, { ref: !lastLoginTime ? focusRef : null, variant: "outline", size: "sm", text: "Log Out", onClick: handleLogout, id: "profile-menu-logout", allytmln: "profile panel - Log Out", disableFullWidthSmDown: true })));
}
//# sourceMappingURL=LogoutButton.js.map